type PostPresentationInput = {
  text?: unknown;
  attachmentType?: unknown;
  attachmentStoragePath?: unknown;
  attachmentUrl?: unknown;
  images?: unknown;
  imageUrls?: unknown;
};

const SHORT_TEXT_MAX_CHARACTERS = 180;
const SHORT_TEXT_MAX_LINES = 3;

export function isShortTextOnlyPost(post: PostPresentationInput) {
  const text = typeof post.text === "string" ? post.text.trim() : "";
  if (!text || text.length > SHORT_TEXT_MAX_CHARACTERS) return false;

  const hasImages = (Array.isArray(post.images) && post.images.length > 0)
    || (Array.isArray(post.imageUrls) && post.imageUrls.length > 0);
  const hasAttachment = post.attachmentType === "pdf"
    || (typeof post.attachmentStoragePath === "string" && post.attachmentStoragePath.length > 0)
    || (typeof post.attachmentUrl === "string" && post.attachmentUrl.length > 0);
  const lineCount = text.split(/\r?\n/).length;

  return !hasImages && !hasAttachment && lineCount <= SHORT_TEXT_MAX_LINES;
}
